import { FieldArray } from 'formik'
import React, { useMemo, useRef } from 'react'
import { InputAcomodacao, InputAcomodacaoDinamico, InputTipoGuia, InputTipoGuiaDinamico } from '../../../../components/InputsAutoCompleteV2'
import { Overlay, Tooltip } from 'react-bootstrap'
import { FiAlertTriangle } from 'react-icons/fi'

const ContratoTipoGuiaAcomodacao = (props) => {
    const refTipoGuiaAcomodacao = useRef(null)

    const changeTipoGuia = (option, propsFormik, arrayHelpers, index) => {
        if (option) {
            if ((index + 1) === propsFormik.values.tipo_guia_acomodacao.length) {
                adicionarLinha(arrayHelpers, propsFormik)
            }
        }
    }

    const adicionarLinha = (arrayHelpers, propsFormik) => {
        arrayHelpers.insert(propsFormik.values.tipo_guia_acomodacao.length, { tipo_guia: null, acomodacoes: [] })
    }

    const removerLinha = (arrayHelpers, propsFormik, index) => {
        const arrayProced = propsFormik.values.tipo_guia_acomodacao;
        if (arrayProced[index].tipo_guia && arrayProced[index].tipo_guia.value)
            arrayHelpers.remove(index)

        if (arrayProced.length === 1 && arrayProced[index].tipo_guia && arrayProced[index].tipo_guia.value)
            arrayHelpers.insert(propsFormik.values.tipo_guia_acomodacao.length, { tipo_guia: null, acomodacoes: [] })
    }

    const acomodacaoMemo = useMemo(() => props.contratoAcomodacao, [props.contratoAcomodacao])
    const acomodacaoMapeada = useMemo(() => {
        return acomodacaoMemo ? acomodacaoMemo.map(item => item.acomodacao) : [];
    }, [acomodacaoMemo]);

    return (
        <>
            <table className='table tabela-endereco table-responsive-md table-striped tabela'>
                <thead>
                    <tr>
                        <th style={{ width: '5%' }}>#</th>
                        <th style={{ width: '40%' }}>Tipo Guia</th>
                        <th style={{ width: '40%' }}>Acomodação(ões)</th>
                        <th style={{ width: '15%' }} className='text-center'>Ações</th>
                    </tr>
                </thead>
                <tbody ref={refTipoGuiaAcomodacao}>
                    <FieldArray name="tipo_guia_acomodacao">
                        {(arrayHelpers) => (
                            props.propsFormik.values && props.propsFormik.values.tipo_guia_acomodacao?.length > 0 && props.propsFormik.values.tipo_guia_acomodacao.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left' }}>{index + 1}</td>
                                    <td>
                                        <InputTipoGuiaDinamico
                                            propsFormik={props.propsFormik}
                                            name={`tipo_guia_acomodacao[${index}].tipo_guia`}
                                            className="mb-0 col-12 col-md-6 col-xl-12 pl-0"
                                            onChange={(option) => {
                                                props.propsFormik.setFieldValue(`tipo_guia_acomodacao[${index}].tipo_guia`, option);
                                                changeTipoGuia(option, props.propsFormik, arrayHelpers, index)
                                            }}
                                            tamanho="pl-0 col-12"
                                            placeholder="Tipo Guia"
                                            classeTooltip={'tooltip-input-modal'} />
                                    </td>
                                    <td>
                                        <InputAcomodacaoDinamico
                                            propsFormik={props.propsFormik}
                                            acomodacao={acomodacaoMapeada}
                                            name={`tipo_guia_acomodacao[${index}].acomodacoes`}
                                            className="mb-0 col-12 pl-0 col-md-6 col-xl-12"
                                            tamanho="pl-0 col-12"
                                            multiplo
                                            obrigatorio
                                            placeholder="Acomodação(ões)"
                                            classeTooltip={'tooltip-input-modal'}
                                        />
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                        <span className='icon-consulta icon-New-Trash'
                                            onClick={target => removerLinha(arrayHelpers, props.propsFormik, index)}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </FieldArray>
                    {props.propsFormik.values.tipo_guia_acomodacao && props.propsFormik.values.tipo_guia_acomodacao.filter(x => x && x.tipo_guia).length > 0 && props.propsFormik.errors.tipo_guia_acomodacao && !Array.isArray(props.propsFormik.errors.tipo_guia_acomodacao) ?
                        <Overlay target={refTipoGuiaAcomodacao.current} show={true} placement="bottom">
                            {props2 => (
                                <Tooltip id={Math.random()} className={"error-tooltip tooltip-input-modal"} {...props2}>
                                    <div className="error">
                                        <FiAlertTriangle className="icone" /> <span>{props.propsFormik.errors.tipo_guia_acomodacao}</span></div>
                                </Tooltip>
                            )}
                        </Overlay> : <></>}
                </tbody>
            </table>
        </>
    )
}

export default React.memo(ContratoTipoGuiaAcomodacao)
